import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { Button, Icon, Tooltip } from 'antd';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Upload } from 'components/ui/index';
import { getAuthorization } from 'utils/common';
import styles from '../emailTemplatesCreation.less';

const cx = classNames.bind(styles);

class ImportTemplateButton extends Component {
  state = {
    url: ''
  };


  addTemplate = () => {
    const { editorState, onChange } = this.props;
    onChange(this.props.modifier(editorState, this.state.url));
  };

  changeUrl = (evt) => {
    this.setState({ url: evt.target.value });
  }
  onAllDone(response, error) {
    const { setTemplateContent } = this.props;
    if (_.isEmpty(error)) {
      response && setTemplateContent(response[0].content);
    }
  }
  render() {
    const { formatMessage } = this.props.intl;
    const uploadProps = {
      name: 'document',
      action: '/admin/email_templates/zip_file',
      accept: '[application/x-zip-compressed, application/x-rar-compressed, application/zip, application/rar]',
      withCredentials: true,
      headers: {
        Authorization: getAuthorization(),
      },
    };
    const hint = (
      <React.Fragment>
        <div>{formatMessage({ id: 'page.emailTemplates.importTemplateHintLine1' })}</div>
        <div>{formatMessage({ id: 'page.emailTemplates.importTemplateHintLine2' })}</div>
      </React.Fragment>
    );
    return (
      <Upload style={{ display: 'inline-block' }} isShowMaxSizeTip={false} uploadConfig={uploadProps} onAllDone={(response, error) => this.onAllDone(response, error)} key={Math.random()}>
        <Tooltip title={hint}>
          <Button size="small" className={`mr-md email-theme-btn ${cx('new-template-link-button')}`}>
            <Icon className={cx('new-template-import-icon')} type="download" /> Import HTML Template
          </Button>
        </Tooltip>
      </Upload>
    );
  }
}

ImportTemplateButton.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(ImportTemplateButton);



// WEBPACK FOOTER //
// ./src/views/email/emailTemplatesCreation/component/importTemplate.js